import React from "react";
const WarningIcon = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      transform: "rotate(180deg)"
    }
  }, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4564",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm.995 9.464h-1.996c-.106 0-.2.038-.28.112a.374.374 0 00-.119.287v7.504c0 .106.04.2.12.28.08.08.173.119.28.119h1.995a.414.414 0 00.295-.112c.08-.074.12-.17.12-.287V9.863a.375.375 0 00-.12-.287.418.418 0 00-.295-.112zm0-3.464h-1.996c-.106 0-.2.04-.28.12a.4.4 0 00-.119.295V7.9c0 .117.037.215.112.295.074.08.17.12.287.12h1.996a.4.4 0 00.295-.12.4.4 0 00.12-.295V6.415a.4.4 0 00-.12-.295.4.4 0 00-.295-.12z"
  })));
};
export default WarningIcon;